import RouteTemplate from 'ember-route-template'
import { t } from 'ember-intl'
import { ReportingControls } from 'teacher-ui-client/components/reporting/controls'
import { ReportingControlsGap } from 'teacher-ui-client/components/reporting/controls-gap'
import { ReportingUiScopeSelect } from 'teacher-ui-client/components/reporting/ui-scope-select'
import { ReportingPeriodSelect } from 'teacher-ui-client/components/reporting/period-select'
import { ReportingExportSelect, ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import type RexReadAloudIndexController from 'teacher-ui-client/reporting/ui-scope/rex/read-aloud-fluency/index/controller'
import type RexReadAloudIndexRoute from 'teacher-ui-client/reporting/ui-scope/rex/read-aloud-fluency/index/route'
import { array } from '@ember/helper'
import { hash } from '@ember/helper'
import type { TOC } from '@ember/component/template-only'
import { ReportLoader as StudentsTableReportLoader } from 'teacher-ui-client/components/reporting/reading-eggspress/read-aloud-fluency/students-table/report-loader'
import { CreateAssignmentLink } from 'teacher-ui-client/components/reporting/reading-eggspress/read-aloud-fluency/create-assignment-link'

interface Signature {
  Args: {
    model: ModelFor<RexReadAloudIndexRoute>
    controller: RexReadAloudIndexController
  }
}

export const RexReadAloudPage: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.readAloudFluency"}} />
  <ReportingControls>
    <ReportingUiScopeSelect class="shrink basis-80" />
    <ReportingControlsGap />
    <ReportingPeriodSelect />
    <ReportingControlsGap />
    <ReportingExportSelect @exportOptions={{array (hash exportType=ExportType.print)}} />
    <CreateAssignmentLink />
  </ReportingControls>
  <div class="space-y-4">
    <StudentsTableReportLoader
      @uiScope={{@model.uiScope}}
      @period={{@model.period}}
      @sort={{@controller.sort}}
      @pageNumber={{@controller.pageNumber}}
      @perPage={{@controller.perPage}}
    />
  </div>
</template>

export default RouteTemplate(RexReadAloudPage)
